import { useState } from "react";
import { Dialog, DialogContent, DialogTitle, Stack, Typography, useMediaQuery, useTheme } from "@mui/material";
import DialogCloseButton from "../../../components/Buttons/DialogCloseButton";
import { CustomerDto, CustomerType } from "../../../interfaces/IEvent";
import { AffectedInfo } from "./AffectedInfo";
import InputField from "../../../components/InputFields/InputField";
import { EntityLink } from "../../../components/AffectedEntities/EntityLink";

interface CustomerInfoDialogProps {
    title: string;
    customerType: CustomerType | string;
    customer: CustomerDto[] | string[] | null;
    locations?: string[];
    open: boolean;
    onClose: () => void;
}

export function AffectedInfoDialog( { title, customerType, customer, open, onClose }: CustomerInfoDialogProps ) {
    const [search, setSearch] = useState<string>("");
    const theme = useTheme();
    const smXsDown = useMediaQuery(theme.breakpoints.down('sm'));

    const handleClose = () => {
        onClose();
        setSearch("");
    };

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            maxWidth={"md"}
            fullWidth
            fullScreen={smXsDown}
        >
            <DialogTitle sx={{ pb: 0}}>
                <Stack sx={{
                    rowGap: 2
                }}>
                    <>{title}</>
                    <>{customerType !== "Telefon" && customerType !== "Epost" &&
                        <InputField
                            name="Søk etter kunde"
                            placeholder="Søk etter kunde"
                            variant="standard"
                            bgColor="none"
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                            maxLength={40}
                        />
                    }</>
                </Stack>
            </DialogTitle>
            <DialogCloseButton handleClose={handleClose} />
            <DialogContent sx={{ pt: 0 }}>
                {customerType === "Telefon" || customerType === "Epost" ?
                    <Typography variant="body2">
                        {(customer as string[] | null)?.map((item, i) => (
                            <span key={item}>
                                {i > 0 && ", "}
                                <EntityLink
                                    kind={customerType === "Telefon" ? "PhoneNumber" : "EmailAddress"}
                                    value={item}
                                    onNavigate={handleClose}
                                >
                                    {item}
                                </EntityLink>
                            </span>
                        ))}
                    </Typography>
                :
                    <AffectedInfo search={search} customer={customer as CustomerDto[]} onNavigate={handleClose} />
                }
            </DialogContent>
        </Dialog>
    );
}